import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { LabelService } from '../../services/label.service';

@Component({
  selector: 'app-panel-with-text-area',
  standalone: false,
  templateUrl: './panel-with-text-area.component.html',
  styleUrl: './panel-with-text-area.component.scss',
})
export class PanelWithTextAreaComponent implements OnChanges {
  @Input() title: string = '';
  @Input() text?: string;
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<string>();
  noteText = '';

  isBtnClicked: boolean = false;

  constructor(public labelService: LabelService) {}

  ngOnChanges(changes: SimpleChanges) {
    // Verifica se la proprietà 'text' è stata aggiornata
    if (changes['text'] && changes['text'].currentValue) {
      this.noteText = changes['text'].currentValue;
    }
  }

  onClose() {
    this.close.emit();
  }

  onConfirm() {
    if (this.isBtnClicked) {
      return;
    }
    this.isBtnClicked = true;
    this.confirm.emit(this.noteText);
  }
}
